<template>
  <div>
    <MainPageHeader/>
    <div v-if="applicationAdded === true" class="app-added">Twoja aplikacja została wysłana!</div>
    <div class="career-content">
      <h1>Kogo zatrudnimy?</h1>
      <div class="offers">
        <details class="offer" v-for="offer in offers" :key="offer.id" :open="offerId == offer.id">
          <summary>{{ offer.title }}</summary>
          <p>
            <CareerOffer />
          </p>
          <form action="" @submit.stop.prevent="sendApplication">
            <fieldset>
              <legend>Złóż aplikację:</legend>
              <input type="hidden" name="offer" :value="offer.shortcode" />
              <label>
                <span>Imię:</span>
                <input type="text" name="name" required />
              </label>

              <label>
                <span>Nazwisko:</span>
                <input type="text" name="lastname" required />
              </label>

              <label>
                <span>E-mail:</span>
                <input type="email" name="email" required />
              </label>

              <label>
                <span>Telefon:</span>
                <input type="text" name="phone" @input="addSpaces" required />
              </label>

              <label>
                <span>CV:</span>
                <div class="upload-field" @drop.prevent="dropCV" @dragover.prevent>
                  <span>Upuść plik tutaj <br/> lub</span>
                  <input
                    type="file"
                    name="cv"
                    class="cv-upload"
                    style="display:none"
                    accept="application/pdf, text/plain, image/jpeg, image/jpg, image/png"
                    @change="isFileSelected($event, offer)"
                    required />
                  <button @click.prevent="clickFileInput">Wybierz plik</button>
                  <span style="color:red" v-if="offer.selectedFile == null">Nie wybrano pliku</span>
                  <span v-else>Wybrany plik: {{ offer.selectedFile.name }}</span>
                </div>
              </label>
              <input type="submit" value="Wyślij">
            </fieldset>
          </form>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import CareerOffer from '../components/CareerOffer.vue'
import { getCareersService } from '@/services/careersService'

export default {
  name: "Careers",
  components: {
    MainPageHeader,
    CareerOffer
  },
  props: ['offerId'],
  data() {
    return {
      applicationAdded: false,
      offers: [
        {
          id: 1,
          title: "Senior Frontend Developer",
          shortcode: "senior_frontend",
          selectedFile: null
        },
        {
          id: 2,
          title: "Senior Kotlin Developer",
          shortcode: "senior_kotlin",
          selectedFile: null
        },
        {
          id: 3,
          title: "Backend developer",
          shortcode: "backend",
          selectedFile: null
        },
        {
          id: 4,
          title: "Stażysta/Praktykant Kotlin",
          shortcode: "praktykant_kotlin",
          selectedFile: null
        },
        {
          id: 5,
          title: "Stażysta/Praktykant Frontend",
          shortcode: "praktykant_frontend",
          selectedFile: null
        },
        {
          id: 6,
          title: "Ambasador marki Vocale - Przedstawiciel handlowy",
          shortcode: "ambasador",
          selectedFile: null
        }
      ]
    }
  },
  methods: {
    isFileSelected(e, offer) {
      if(e.target.files.length > 0) {
        console.log(e.target.files[0])
        offer.selectedFile = e.target.files[0]
      } else {
        offer.selectedFile = null
      }
    },
    clickFileInput(e) {
      let input = e.path[1].querySelector('input')
      input.click()
    },
    addSpaces: function(e) {
        e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
        if(e.target.value.length > 11) {
          e.target.value = e.target.value.substr(0, 11)
        }
    },
    dropCV(e) {
      let fileInput = e.currentTarget.childNodes[1]
      fileInput.files = e.dataTransfer.files
    },
    async sendApplication(e) {
      let elements = e.target.elements,
          data = new FormData()

      data.append('offer', elements.offer.value)
      data.append('name', elements.name.value)
      data.append('lastname', elements.lastname.value)
      data.append('email', elements.email.value)
      data.append('phone', elements.phone.value)
      data.append('cv', elements.cv.files[0])
      
      await getCareersService().createApplication(data)

      window.scrollTo(0,0)
      this.applicationAdded = true
      setTimeout(() => {
        this.applicationAdded = false
      }, 5000)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.career-content {
  border-top: solid 2px gray;
  margin-top: 91px;
  & > h1 {
    text-align: center;
    margin: 2rem 0;
  }
  .offers {
    margin: auto;
    max-width: 640px;
    margin-bottom: 4rem;
    .offer {
      summary {
        cursor: pointer;
        font-weight: bold;
        color: $gold;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      & > p {
        padding-left: 2rem;
      }
      form {
        padding-left: 2rem;
        .upload-field {
          text-align: center;
          padding: 2rem 0;
          border: dashed 1px $gold;
          margin-bottom: 1rem;
          line-height: 24px;
        }
        input[type=submit] {
          width: 100%;
          padding: 1rem;
          background: $gold;
          border: none;
          color: #fff;
          font-size: 22px;
          border-radius: unset;
        }
        label {
          display: block;
          span {
            display: block;
            font-size: 15px;
          }
          input {
            color: #fff;
            background: none;
            border: none;
            margin-bottom: 6px;
            &[type=email], &[type=text] {
              border-bottom: solid 1px $gold;
              font-size: 18px;
              padding: 6px;
            }
            &:focus {
              outline: none;
            }
          }
        }
        fieldset {
          border-color: gray;
        }
      }
    }
  }
}

.app-added {
  padding: 1rem;
  background: $gold;
  color: #fff;
  z-index: 999;
  position: fixed;
  font-size: 48px;
  max-width: 600px;
  left: 50%;
  top: 32px;
  transform: translateX(-50%);
  animation: fade 5s;
  animation-fill-mode: forwards; 
  text-align: center;
  font-family: Verdana, sans-serif;
}

@keyframes fade {
  0% { opacity: 0 }
  25%, 75% { opacity: 1 }
  100% { opacity: 0 }
}

details>summary {
  list-style: none;
}

summary::-webkit-details-marker {
  display: none
}

summary::after {
  content: ' ›';
  font-size: 3rem;
  transform: rotate(90deg);
}

details[open] summary:after {
  transform: rotate(180deg);
}
</style>